/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const MRPService = {

  /**
   * Save MRP Header
   * @param {*} payload 
   * @returns 
   */
  async save(payload) {
    const url = `api/MRPHeader/SaveMRPHeader`;
    return await ApiService.post(url, payload);
  },

  /**
   * Get MRP Header by MRPRun
   * @param {*} MRPRun 
   * @returns 
   */
  async getMRPHeader(MRPRun) {
    const requestScreenData = {
      url: "api/MRPHeader",
      filter: "MRPRun eq " + MRPRun,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

};

export { MRPService };
